import { Component, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { EventDataService } from "..";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/event/i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "event-linkable",
    templateUrl: "./event-linkable.component.html",
    styleUrls: ["./event-linkable.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [LinkableComponent],
})
export class EventLinkableComponent extends ItemLinkableBase {
    private _eventDS = inject(EventDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translation = injectTranslation(scope);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._eventDS.hasAccessToEvent(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.EventDetail,
                item.guid,
                `(E) ${item[this.displayValueProp]}`
            );
        } else {
            // t() needs the scope loaded first; before ready() it throws in development.
            await this._translation.ready();
            this._toastr.warning(
                this._translation.t("eventLinkable.notEnoughRights")
            );
        }
    }
}
